import React from 'react';

const SurveySymptomCmplt = () => {
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '75vh',
  };

  return (
    <div style={containerStyle}>
      <div className="comp-msg">
        <div className="comp-msg-wrap">
          증상 조사표 작성이
          <br />
          <span className="point">완료</span>되었습니다.
        </div>
      </div>
    </div>
  );
};

export default SurveySymptomCmplt;
